import script from "./NewList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewList.vue?vue&type=script&setup=true&lang=js"

import "./NewList.vue?vue&type=style&index=0&id=313507d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313507d4"]])

export default __exports__